import { CircleInfo } from '@unified-checkout/design-system/icons/index';
import { SkeletonLoader } from '@unified-checkout/design-system';

import { AnnouncementBox } from '@app/dashboard/components/inner_layout/AnnouncementBox';
import { PROGRESS_BANNER_ICON } from '@app/dashboard/constants/balance_and_transfers/single-transfer';

import type { IProgressProps } from '@app/dashboard/types/innerLayout/balance_and_transfers/single-transfer/progress';
import { BALANCE_TRANSFERS_EVENTS_VALUES } from '@app/dashboard/constants/tracking_events/balance-and-transfers';

import TransferTimeline from '../../../../components/TransferTimeline';

import styles from './progress.module.scss';

const Progress = ({
  transferProgress,
  header,
  isLoading,
  transferId,
  settlementType,
}: IProgressProps) => {
  const status = header ? header.status.key : null;
  const announcementIcon = status
    ? PROGRESS_BANNER_ICON[status as keyof typeof PROGRESS_BANNER_ICON]
    : null;

  return (
    <div className={styles['progress']} data-progress-status={status}>
      {isLoading ? (
        <SkeletonLoader
          noOfRows={2}
          width="100%"
          type="bordered_box"
          height="5.75rem"
        />
      ) : (
        <AnnouncementBox
          type="progress"
          status={announcementIcon?.type ?? 'brand'}
          title={header?.banner?.title || ''}
          description={header?.banner?.message || ''}
          icon={announcementIcon?.icon || CircleInfo}
        />
      )}
      <TransferTimeline
        transferProgress={transferProgress}
        header={header}
        isLoading={isLoading}
        transferId={transferId}
        settlementType={settlementType}
        entryPoint={BALANCE_TRANSFERS_EVENTS_VALUES.DETAILS}
      />
    </div>
  );
};

export default Progress;
